import React, { Component } from "react";
import Image from "../Image";
export default class UploadFile extends Component {
  render() {
    const {
      id,
      isShowError,
      fileName,
      fileType,
      fileSize,
      errorMessage,
      title,
    } = this.props;
    return (
      <React.Fragment>
        <div
          className="upload_main"
          style={{
            borderColor:
              this.props.disabled || isShowError ? "red" : "lightblue",
            cursor: this.props.disabled ? "not-allowed" : "pointer",
          }}
        >
          <label htmlFor={id} className="upload-label">
            <div style={{ display: "flex" }}>
              <Image
                src={"/images/upload.svg"}
                style={{ height: 15 }}
                alt="upload_icon"
              />
              <div
                style={{
                  fontSize: 14,
                  color: "#007ac8",
                  fontFamily: "OpenSans-SemiBold",
                  marginLeft: 10,
                }}
              >
                {title || "Upload"}
              </div>
            </div>
          </label>
          <div style={{ padding: "20px 20px 0px", wordBreak: "break-all" }}>
            {" "}
            {fileName}
          </div>
          <div style={{ padding: "20px 20px 0px" }}>
            {" "}
            {fileSize}
            {!!fileSize && "Kb"}
          </div>
        </div>
        <input
          type="file"
          id={id}
          accept={!!fileType ? fileType : ".pdf"}
          style={{
            display: "none",
          }}
          onChange={this.props.uploadFile(id)}
          disabled={this.props.disabled}
        />
        <div className="nps-error-message">
          {isShowError ? errorMessage : ""}
        </div>
      </React.Fragment>
    );
  }
}
